
const DaySquareOffNotice = () => {
  return (
    <div className="day-squareoff-notice">
      <div className="day-squareoff-notice__container">
        <p className="day-squareoff-notice__text">
          <i className="fa-regular fa-circle-check"></i>
          Strategy squared off for today. No further trades will occur unless restarted. It will automatically receive signals on the next trading day.
        </p>
      </div>
    </div>
  );
};

export default DaySquareOffNotice;
